###
 # @desc produces a select box with additional button to create entities of the
 # specified type.
 #
 # @param createForm   the sequenced form id to use on create
 # @param mode         when set to 'multiple', multiple entities can be selected

###

import { useState, useEffect } from 'react'
import { Select, Divider, Input, Button } from 'antd'
import { showActionsPage } from 'Components'
import { Macro } from 'Model'
import { getDataOptions, getRepeatCount } from '../helpers'
import { getProjectData, getNodeLabel } from 'Services/WeaverUtils'
import withDerivedData from './withDerivedData'
import withRepeater from './withRepeater'
{ Option } = Select

SequencedFormSelectOrCreate = ({
  form
  formItem
  label
  config = { mode, showSearch } = {}
  derivedData
  queries
  editPermissions = []
  initializing
  props...
}) ->
  {
    createForm
    mode = undefined
    className
    repeatOn
  } = config

  className ?= label

  [disabled, setDisabled] = useState(false)
  [newEntityName, setNewEntityName] = useState(undefined)
  [options, setOptions] = useState([])

  derived = withDerivedData({
    queries,
    derivedData
  })
  { initting } = derived
  existingOptions = derived.options

  useEffect( ->
    setOptions(existingOptions)
    return if initting or !props.value
    toTest = (val) ->
      if mode is 'multiple'
        val in props.value
      else
        val is props.value

    if !options.find(({ value }) -> toTest(value))
      props.onChange(undefined)
    undefined
  , [existingOptions])

  useEffect( ->
    setDisabled(options.length is 0)
    return if initting or !props.value
    isValInOptions = (val) ->
      options.find(({ value }) -> value is val)
    if mode is 'multiple'
      valid = (props.value or []).filter(isValInOptions)
      if !_.isEqual(valid, props.value) then props.onChange(valid)
    else
      if !isValInOptions(props.value) then props.onChange(undefined)
    undefined
  , [options])

  # callback method that will be executed after an entity is created and sets
  # the entity as value for the field that invoked the create-action
  setCreatedItem = (node, data) ->
    { queryLabelAttr } = derivedData
    itemValue = node.id()
    label = getNodeLabel(node)

    setOptions([options..., { label, value: itemValue }])
    if mode and mode is 'multiple'
      props.onChange([(props.value or [])..., itemValue])
    else
      props.onChange(itemValue)

  <Select
    showSearch
    mode={mode}
    style={{ width: '100%', marginBottom: 5 }}
    placeholder="Select or create #{ className }"
    optionFilterProp="children"
    filterOption={(input, option) ->
      option.children.props.children.join('').toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
    onDeselect={(selectedValue)->
      props.onChange({ [formItem]: value.filter((i) -> i isnt selectedValue) })
    }
    dropdownRender={(menu) -> (
      <div>
        { menu }
        <Divider style={{ margin: '4px 0' }} />
        <div style={{ display: 'flex', flexWrap: 'nowrap', padding: 8 }}>
          <Button
            type="primary"
            onClick={->
              conf = (await Macro.load(createForm)).get('configBlob')
              showActionsPage({ conf..., formCallback: setCreatedItem })
            }
          >
            New { className }
          </Button>
        </div>
      </div>
    )}
    { props... }
  >
    {options.map((option) ->
      option.value ?= option
      <Option
        disabled={option.disabled or false}
        key={option.value}
        value={option.value}
      >
        { option.label }
      </Option>
    )}
  </Select>

export default withRepeater(SequencedFormSelectOrCreate, { selector: (value) -> value })
